<template>
  <div class="result-area">
    <div class="result-area__wrapper">
      <div class="result-area__sidebar">
        <hotel-filters
          ref="hotelfilters"
          :loadingOffers="loadingOffers"
          :loadingFilters="loadingFilters"
          :filterError="filterError"
        ></hotel-filters>
      </div>
      <div class="result-area__content">
        <result-bar
          ref="resultbar"
          :show-search="offer_error ? true : false"
        ></result-bar>
        <div class="hotel-grid">
          <hotel-block
            v-for="(hotelBlock, hotelKey) in hotelBlocks"
            :hotel="hotelBlock"
            :key="hotelKey"
          ></hotel-block>
          <div class="result-area__no-results" v-if="offer_error">
            <h4 v-text="offer_error.header"></h4>
            <p v-text="offer_error.text"></p>
            <button
              class="btn btn--positive"
              v-if="error_action == 'change_traveldates'"
              v-text="translations.btn_change_traveldates"
              @click="openCalendar"
            ></button>

            <button
              class="btn btn--positive"
              v-if="error_action == 'reset_filters'"
              v-text="translations.btn_reset_filters"
              @click="resetFilters"
            ></button>
          </div>
        </div>
        <div class="result-area__content__buttons" v-if="!offer_error">
          <button
            class="btn btn--more-hotels"
            v-if="moreOffers"
            v-text="translations.load_more_items"
            @click="$emit('loadmore')"
          ></button>
          <button class="btn btn--alt btn--filters" @click="gotoFilters">
            <span v-text="translations.filter_items_btn"></span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 395.65 223"
              class="icon-dropdown"
            >
              <path
                d="M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                style="fill: #fff"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import HotelBlock from "./hotel-block/hotel-block.vue";
import ResultBar from "./result-bar.vue";
import HotelFilters from "./hotel-filters.vue";
import _ from "underscore";
import Moment from "moment";
import CookieJS from "js-cookie";
import { scrollIntoView } from "scroll-js";

export default {
  props: {
    loadingOffers: { type: Boolean, default: true },
    errorCode: { type: Number, default: null },
    filterError: { type: Boolean, default: false },
    loadingFilters: { type: Boolean, default: false },
  },
  data() {
    return {
      translations: APP_CONFIG.TRANSLATION.HOTEL_AREA,
      showFirstRating: false,
    };
  },
  methods: {
    checkRating() {
      if (!CookieJS.get("hide-rating")) {
        let expires = Moment().add(1, "years").toDate();
        CookieJS.set("hide-rating", true, { expires });
        return true;
      }

      return false;
    },
    gotoFilters() {
      let scrollContainer =
        document.documentElement.scrollTop > 0
          ? document.documentElement
          : document.body;
      scrollIntoView(this.$el, scrollContainer).then(() => {
        this.$refs.hotelfilters.openFilterList();
      });
    },
    openCalendar() {
      if (this.$refs.resultbar) {
        this.$refs.resultbar.openCalendar();
      }
    },
    resetFilters() {
      this.$router.push({
        path: "/hotels",
        query: _.pick(this.$route.query, [
          "fromDate",
          "toDate",
          "departureAirport",
          "destinationId",
          "adults",
          "childrenCount",
          "children",
          "flexibleStartDays",
          "flexibleEndDays",
        ]),
      });
    },
  },
  watch: {
    loadingOffers() {
      if (!this.loadingOffers) {
        this.showFirstRating = this.checkRating();
      }
    },
  },
  computed: {
    hasFiltersSet() {
      let filterQuery = this.$store.getters.travelFilterQuery;
      return filterQuery.minPrice ||
        filterQuery.maxPrice ||
        filterQuery.directFlight == "true" ||
        filterQuery.roomTypeCode ||
        filterQuery.boardTypeCode ||
        filterQuery.roomLocatedCode ||
        filterQuery.locationId ||
        (filterQuery.keywords && filterQuery.keywords.length) ||
        (filterQuery.tourOperator && filterQuery.tourOperator.length)
        ? true
        : false;
    },
    error_action() {
      switch (this.errorCode) {
        case 404:
          return this.hasFiltersSet ? "reset_filters" : "change_traveldates";
        case 500:
          return "change_traveldates";
        default:
          return null;
      }
    },
    offer_error() {
      switch (this.errorCode) {
        case 404:
          return this.hasFiltersSet
            ? this.translations.ERRORS.no_result_filters
            : this.translations.ERRORS.no_result;
        case 500:
          return this.translations.ERRORS.server_error;
        case 0:
          return this.translations.ERRORS.network_error;
        default:
          return null;
      }
    },
    hotelBlocks() {
      if (!this.$store.state.offers.length && this.loadingOffers) {
        return [
          { loading: true },
          { loading: true },
          { loading: true },
          { loading: true },
          { loading: true },
          { loading: true },
        ];
      }

      let firstRatingShown = false;
      return this.$store.state.offers
        .filter((offer) => offer.hotelOffer)
        .map((offer, key) => {
          let rating =
            _.propertyOf(offer)(["hotelOffer", "hotel", "rating"]) || {};

          let showRating = false;
          if (!_.isEmpty(rating) && !firstRatingShown && this.showFirstRating) {
            firstRatingShown = true;
            showRating = true;
          }

          return {
            id: _.propertyOf(offer)(["hotelOffer", "hotel", "id"]) || null,
            title: _.propertyOf(offer)(["hotelOffer", "hotel", "name"]) || "",
            location:
              _.propertyOf(offer)([
                "hotelOffer",
                "hotel",
                "location",
                "name",
              ]) || "",
            rating,
            stars:
              _.propertyOf(offer)(["hotelOffer", "hotel", "category"]) || 0,
            img:
              _.propertyOf(offer)([
                "hotelOffer",
                "hotel",
                "mediaData",
                "thumbnail",
              ]) || "",
            description:
              _.propertyOf(offer)([
                "hotelOffer",
                "hotel",
                "mediaData",
                "previewText",
                "text",
              ]) || "",
            dateFrom: Moment(offer.travelDate.fromDate),
            dateTo: Moment(offer.travelDate.toDate),
            totalPrice: _.propertyOf(offer)(["totalPrice", "value"]) || null,
            totalPriceEuro: _.propertyOf(offer)(["totalPriceEuro"]) || null,
            currency: _.propertyOf(offer)(["totalPrice", "currency"]) || "",
            showRating,
          };
        });
    },
    moreOffers() {
      return (
        this.$store.getters.currentNumberOfMissingOffers > 0 &&
        this.hotelBlocks.length > 0
      );
    },
  },
  components: {
    HotelBlock,
    ResultBar,
    HotelFilters,
  },
};
</script>